(() => {
  const selector = [
    '.oylin-reveal',
    '.oylin-statement',
    '.oylin-material-section',
    '.oylin-process',
    '.oylin-product-teaser',
    '.oylin-journal-section',
    '.oylin-cta-banner',
    '.oylin-bespoke-form',
    '.oylin-editorial',
    '.oylin-section',
    '.oylin-page-intro',
    '.oylin-brand-page',
    '.oylin-technical-page',
    '.oylin-article',
  ].join(',');

  function reveal(element) {
    element.classList.add('oylin-is-visible');
  }

  function revealAll(root = document) {
    root.querySelectorAll(selector).forEach(reveal);
  }

  function init(root = document) {
    const elements = Array.from(root.querySelectorAll(selector)).filter(
      (element) => !element.dataset.oylinRevealBound && !element.classList.contains('oylin-hero'),
    );

    if (!elements.length) return;

    if (
      document.documentElement.classList.contains('shopify-design-mode') ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      elements.forEach((element) => {
        element.dataset.oylinRevealBound = 'true';
        reveal(element);
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries, instance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          instance.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' },
    );

    elements.forEach((element) => {
      element.dataset.oylinRevealBound = 'true';
      observer.observe(element);
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
    revealAll(event.target);
  });
})();